var _rect, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalreward(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "bgtotalreward",
    cx: "50%",
    cy: "30%",
    r: "70%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#F39C12"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#D68910"
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 100,
    height: 100,
    rx: 16,
    fill: "url(#bgtotalreward)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 55,
    fontFamily: "Arial",
    fontSize: 36,
    textAnchor: "middle",
    fill: "white"
  }, "\uD83C\uDF81")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 85,
    fontFamily: "Arial",
    fontSize: 13,
    fontWeight: "bold",
    textAnchor: "middle",
    fill: "white"
  }, "TOTAL")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalreward);
export default __webpack_public_path__ + "static/media/totalreward.3fb021cc16f73a302c9729b02191fb38.svg";
export { ForwardRef as ReactComponent };